import { WBBox, WBIcon, WBTooltip } from '../..';

export interface InformationIconProps {
  title?: string;
}

export function InformationIcon({ title }: InformationIconProps) {
  const hasInfoIcon = !!title;

  return hasInfoIcon ? (
    <WBTooltip title={title}>
      <WBBox component="span" sx={{ cursor: 'pointer' }}>
        <WBIcon size={2} name="InformationCircle"></WBIcon>
      </WBBox>
    </WBTooltip>
  ) : null;
}

export default InformationIcon;
